// extracted by mini-css-extract-plugin
export default {"highlighted":"_3a7Aj"};